import { Component, Input } from '@angular/core';

type Position = 'left' | 'right';
interface DoubleParams {
  readonly label: string;
  readonly placeholder: string;
  readonly filled: boolean;
}

@Component({
  selector: 'fin-booking-widget-selector',
  templateUrl: 'booking-widget-selector.component.html',
  styleUrls: ['./booking-widget-selector.component.scss'],
})
export class BookingWidgetSelectorComponent {
  @Input()
  disabled = false;

  @Input()
  label?: string;

  @Input()
  ariaLabel?: string;

  @Input()
  double?: {
    first: DoubleParams;
    second: DoubleParams;
  };

  @Input()
  position?: Position;

  @Input()
  filled?: boolean;

  @Input()
  placeholder?: string;
}
